export default {
    MAX_CHANGE_PWD_ATTEMPT: 3,
    MIN_PASSWORD_LENGTH: 8,
    NO_PATIENT_VISITS: 3,
    MIN_NAME_LENGTH: 2,
    FREE_TERMS_RANGE: 7,
    FIRST_FREE_TERM_FOR_DOCTOR_RANGE: 180,
    MAX_PROFILES_PER_USER: 6,
};
